var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('div',{staticClass:"casual"},[_c('img',{staticClass:"casual__hero",attrs:{"src":require("@/assets/banner/casual.jpg"),"alt":""}}),_c('banner-grid',{attrs:{"path":"casual_banner","banners":[
        'Ace Round',
        'Atlantis',
        'Courier Sweeper',
        'Crown _ Anchor',
        'Dungeon',
        'E.T. Races',
        'Fruit Burst',
        'Heads _ Tails',
        'Mafia Syndicate',
        'Maze',
        'Rise of Horus',
        'Roll the Dice',
        'Surf zone',
        'Temple of dead',
        'Treasure Mania' ]},scopedSlots:_vm._u([_vm._l(([
          'Ace Round',
          'Atlantis',
          'Courier Sweeper',
          'Crown _ Anchor',
          'Dungeon',
          'E.T. Races',
          'Fruit Burst',
          'Heads _ Tails',
          'Mafia Syndicate',
          'Maze',
          'Rise of Horus',
          'Roll the Dice',
          'Surf zone',
          'Temple of dead',
          'Treasure Mania' ]),function(game){return {key:("item-" + game),fn:function(ref){
        var active = ref.active;
return [_c('card-overlay',{key:("overlay-" + game),attrs:{"active":active}},[_c('auth-connector',{scopedSlots:_vm._u([{key:"loggedIn",fn:function(ref){
        var gameUrl = ref.gameUrl;
return [_c('a',{staticClass:"card-overlay__button",attrs:{"href":gameUrl,"target":"_blank"}},[_vm._v(" เล่นเกมส์ ")])]}},{key:"loggedOut",fn:function(){return [_c('dialog-connector',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var openDialog = ref.openDialog;
return [_c('button',{staticClass:"card-overlay__button",on:{"click":function($event){return openDialog('LoginDialog')}}},[_vm._v(" เล่นเกมส์ ")])]}}],null,true)})]},proxy:true}],null,true)})],1)]}}})],null,true)})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }